export type EnglishComfortLevel = 'very_comfortable' | 'comfortable' | 'still_learning' | 'just_beginning';
export type ConcernType = 'understanding' | 'speaking' | 'remembering' | 'interview_process';

export interface Profile {
  id: string;
  email: string | null;
  full_name: string | null;
  interview_date: string | null;
  english_comfort_level: EnglishComfortLevel | null;
  nervous_about: ConcernType[] | null;
  free_attempts_used: number;
  created_at: string;
  updated_at: string;
}

export interface OnboardingData {
  full_name?: string;
  interview_date?: string | null;
  english_comfort_level?: EnglishComfortLevel;
  nervous_about?: ConcernType[];
}

export const ENGLISH_COMFORT_OPTIONS = [
  { value: 'very_comfortable' as const, label: 'Very comfortable', icon: '🌟' },
  { value: 'comfortable' as const, label: 'Comfortable', icon: '😊' },
  { value: 'still_learning' as const, label: 'Still learning', icon: '📚' },
  { value: 'just_beginning' as const, label: 'Just beginning', icon: '🌱' },
];

export const CONCERN_OPTIONS = [
  { value: 'understanding' as const, label: 'Understanding the questions', icon: '👂' },
  { value: 'speaking' as const, label: 'Speaking clearly', icon: '🗣️' },
  { value: 'remembering' as const, label: 'Remembering civics answers', icon: '🧠' },
  { value: 'interview_process' as const, label: 'The interview process', icon: '🏛️' },
];
